import { AUTH_GET, AUTH_POST, AUTH_PUT } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";
import { IExternalIntegrationMappingInput } from "@grudder/types/integration.types";

import { createAsyncThunk } from "@reduxjs/toolkit";

// Async thunk to create a new leadexport
export const createIntegrationConfig = createAsyncThunk("external-integration-config/create", async ({ input, mappings }: { input: any, mappings: IExternalIntegrationMappingInput[] }, { rejectWithValue }) => {

  if (mappings?.length) {
    // Create mappings if provided
    try {
      await createMappings(mappings);

    } catch (error) {

      return rejectWithValue(error);
    }
  }

  try {
    const response = await AUTH_POST(`${config.baseURL}/api/external-integration-configs`, input, {
      tags: ["external-integration-configs", `input:${JSON.stringify(input)}`],
    });
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getExternalIntegrationConfig = createAsyncThunk("external-integration-config/get", async (_, { rejectWithValue }) => {
  try {
    const response = await AUTH_GET(`${config.baseURL}/api/external-integration-configs`, {
      tags: ["external-integration-configs"]
    });
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateExternalIntegrationConfig = createAsyncThunk("external-integration-config/update", async ({ input, integrationId }: { input: any; integrationId: string }, { rejectWithValue }) => {
  try {
    const response = await AUTH_PUT(`${config.baseURL}/api/external-integration-configs/${integrationId}`, input, {
      tags: ["external-integration-configs", `input:${JSON.stringify(input)}`],
    });
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteExternalIntegrationConfig = createAsyncThunk("external-integration-config/delete", async ({ integrationId }: { input: any; integrationId: string }, { rejectWithValue }) => {
  console.log("🚀 ~ integrationId:", integrationId)
  try {
    // const response = await AUTH_DELETE(`${config.baseURL}/api/external-integration-configs/${integrationId}`, {
    //   tags: ["external-integration-configs", `input:${JSON.stringify(integrationId)}`],
    // });
    // return response;

  } catch (error) {
    return rejectWithValue(error);
  }
})

const createMappings = async (mappings: any[]) => {
  if (!mappings || !mappings.length) return;

  const mappingPromises = mappings.map(async (mapping) => {
    const response = await AUTH_POST(`${config.baseURL}/api/lead-external-integration-mapping`, mapping, {
      tags: ["lead-external-integration-mapping", `input:${JSON.stringify(mapping)}`],
    });
    return response;
  });

  return Promise.all(mappingPromises);
};

